export default __webpack_public_path__ + "static/media/battery-75percentage24x24.6d3abe7c.svg";